var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3188 4.43101L8.49985 18.249C8.40694 18.3423 8.29652 18.4163 8.17494 18.4668C8.05336 18.5173 7.923 18.5433 7.79135 18.5433C7.65969 18.5433 7.52933 18.5173 7.40775 18.4668C7.28617 18.4163 7.17576 18.3423 7.08285 18.249L1.73885 12.9C1.64594 12.8067 1.53552 12.7327 1.41394 12.6822C1.29236 12.6317 1.162 12.6057 1.03035 12.6057C0.898693 12.6057 0.768335 12.6317 0.646752 12.6822C0.52517 12.7327 0.414756 12.8067 0.321847 12.9C0.22857 12.9929 0.154557 13.1033 0.104056 13.2249C0.053554 13.3465 0.0275574 13.4769 0.0275574 13.6085C0.0275574 13.7402 0.053554 13.8705 0.104056 13.9921C0.154557 14.1137 0.22857 14.2241 0.321847 14.317L5.66785 19.662C6.23179 20.2249 6.99604 20.5411 7.79285 20.5411C8.58965 20.5411 9.3539 20.2249 9.91785 19.662L23.7358 5.84701C23.829 5.75412 23.9029 5.64377 23.9533 5.52228C24.0037 5.40079 24.0296 5.27054 24.0296 5.13901C24.0296 5.00747 24.0037 4.87723 23.9533 4.75574C23.9029 4.63425 23.829 4.5239 23.7358 4.43101C23.6429 4.33773 23.5325 4.26372 23.4109 4.21322C23.2894 4.16272 23.159 4.13672 23.0273 4.13672C22.8957 4.13672 22.7653 4.16272 22.6438 4.21322C22.5222 4.26372 22.4118 4.33773 22.3188 4.43101Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3a6a2e6a649e4b9991b48f29399e59ea.svg";
export { ForwardRef as ReactComponent };